import { render, staticRenderFns } from "./ThermalComfortWidget.vue?vue&type=template&id=a77e9766&scoped=true&"
import script from "./ThermalComfortWidget.vue?vue&type=script&lang=js&"
export * from "./ThermalComfortWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a77e9766",
  null
  
)

export default component.exports